import Report from '../view/Report.vue';
import Login from '../view/Login.vue';

const routes = [
    {
        path: '/',
        name: '首页',
        component: Report
    },
    {
        path: '/login',
        name: '登录',
        component: Login
    },
]

export {routes};